import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";

const Spinner = ({ size }) => (
  <div className={classnames(styles.spinner, styles[size])} />
);

Spinner.defaultProps = {
  size: "small"
};

Spinner.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"])
};

export default Spinner;



// WEBPACK FOOTER //
// ./template/components/Spinner/index.js